module.exports = __webpack_public_path__ + "img/icon-return-client.e70b0e22.svg";